module.exports = __webpack_public_path__ + "img/7-readaloud.6abb8984.svg";